const cartUpdateErrorsMapping = {
    UnknownUpdateCartFailure: 'checkout.errors.cartUpdateFailed',
    ShippingMethodDoesNotMatchCartFailure: 'checkout.errors.shippingMethodNotMatched',
    ShipmentMethodNotFoundFailure: 'checkout.errors.shippingMethodNotFound'
};
const ApplePaySessionErrors = {
    ApplePaySessionUnsupported: 'checkout.express.apple.pay.errors.unsupported',
    ApplePaySessionFailed: 'checkout.express.apple.pay.errors.failed',
    ApplePayPaymentFailed: 'checkout.express.apple.pay.errors.payment.failed',
    ApplePayInvalidAddress: 'checkout.express.apple.pay.errors.invalid.address'
};
const GooglePaySessionErrors = {
    GooglePaySessionUnsupported: 'checkout.express.google.pay.errors.unsupported',
    GooglePaySessionFailed: 'checkout.express.google.pay.errors.failed',
    GooglePayPaymentFailed: 'checkout.express.google.pay.errors.payment.failed',
    GooglePayInvalidAddress: 'checkout.express.google.pay.errors.invalid.address'
};
var errorsMapping;
(function(errorsMapping) {
    errorsMapping["SOMETHING_WENT_WRONG"] = 'checkout.errors.somethingWentWrong';
    errorsMapping["ORDER_NOT_FOUND"] = 'checkout.errors.orderNotFound';
})(errorsMapping || (errorsMapping = {}));
var CheckoutErrorsMapping;
(function(CheckoutErrorsMapping) {
    CheckoutErrorsMapping["CartNotFound"] = 'cart.errors.cartNotFound';
    CheckoutErrorsMapping["CreateOrderFailed"] = 'checkout.errors.order.message';
    CheckoutErrorsMapping["TryAgain"] = 'common.errors.recoverable.generic';
    CheckoutErrorsMapping["PaymentMethodNotFound"] = 'checkout.errors.paymentMethods.title';
    CheckoutErrorsMapping["PaymentFailed"] = 'checkout.errors.paymentFailed';
    CheckoutErrorsMapping["SomethingWentWrong"] = 'checkout.errors.form.general';
    CheckoutErrorsMapping["CartIdNotFound"] = 'cart.errors.missingCartID';
    CheckoutErrorsMapping["OrderNotFound"] = 'checkout.errors.orderNotFound';
})(CheckoutErrorsMapping || (CheckoutErrorsMapping = {}));
var CreateOrderErrors;
(function(CreateOrderErrors) {
    CreateOrderErrors["UNSUPPORTED_REDIRECT_METHOD"] = "UNSUPPORTED_REDIRECT_METHOD";
    CreateOrderErrors["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    CreateOrderErrors["ORDER_CREATION_CALL_FAILED"] = "ORDER_CREATION_CALL_FAILED";
    CreateOrderErrors["PRODUCT_PRICE_UPDATED"] = "PRODUCT_PRICE_UPDATED";
})(CreateOrderErrors || (CreateOrderErrors = {}));

export { ApplePaySessionErrors, CheckoutErrorsMapping, CreateOrderErrors, GooglePaySessionErrors, cartUpdateErrorsMapping, errorsMapping };
//# sourceMappingURL=errors-mapping.js.map
